import React from "react";
import SurveyView from "../views/SurveyView";
import SurveyViewLatest from "../views/SurveyViewLatest";
import { FormService } from "../../../services/form.service";
import { APP } from "../../../constants";
import Notify from "../../../helpers/notify";
// import { withRouter } from "react-router-dom";

class SurveyContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      surveyId: "",
      surveyDetails: "",
      formData: "",
    };
    this.loadSurveyDetails = this.loadSurveyDetails.bind(this);
    this.getSurveyData = this.getSurveyData.bind(this);
  }

  componentDidMount() {
    if (this.props && this.props.match.params) {
      if (this.props.match.params.code) {
        this.setState(
          {
            surveyId: this.props.match.params.code,
          },
          () => {
            if (this.state.surveyId.length > 25) {
              this.setState({ formData: this.state.surveyId });
              this.loadSurveyDetails(JSON.parse(atob(this.state.surveyId)).id);
            } else {
              this.loadSurveyDetails(this.state.surveyId);
            }
            // this.getUrlParams();
          }
        );
      }
    }

  }

  getUrlParams = () => {
    const search = window.location.search.substring(1);
    const objectArray = search.split("&");
    let urlString = {}, result = [];
    for (let i = 0; i < objectArray.length; i++) {
      const str = objectArray[i];
      const [head] = str.split('=', 1);
      result = [head, str.slice(head.length + 1)]
      urlString = { ...urlString, [result[0]]: result[1] };
    }
    // console.log(urlString);
    return urlString;
  }

  loadSurveyDetails = (id) => {
    FormService.findWoToken(id).then(
      (response) => {
        if (response.statusInfo.statusCode === APP.CODE.SUCCESS) {
          this.setState({
            surveyDetails: response.responseData,
          });
        } else {
          Notify.error(response.statusInfo.errorMessage);
        }
        localStorage.setItem("formId", response.responseData.id);
      },
      (error) => {
        error.statusInfo
          ? Notify.error(error.statusInfo.errorMessage)
          : Notify.error(error.message);
      }
    );
  };

  getSurveyData = (data) => {
    data.meta = this.state.surveyDetails.meta;
    data.infoObject = this.getUrlParams();
    console.log(data);
    FormService.submitForm(data).then(
      (response) => {
        if (response.statusInfo.statusCode === APP.CODE.SUCCESS) {
          Notify.success("Survey submitted. Thank You!");
        } else {
          Notify.error(response.statusInfo.errorMessage);
        }
      },
      (error) => {
        error.statusInfo
          ? Notify.error(error.statusInfo.errorMessage)
          : Notify.error(error.message);
      }
    );
  };

  render() {
    return (
      <div className="container-fluid">
        <div className="mt-3">
          {this.state.surveyDetails &&
            this.state.surveyDetails.id === 1665552412012 ? (
            <SurveyViewLatest
              data={this.state.surveyDetails}
              sendData={this.getSurveyData}
              formData={this.state.formData}
            />
          ) : (
            <div className="mt-3">
              <SurveyView
                data={this.state.surveyDetails}
                sendData={this.getSurveyData}
                formData={this.state.formData}
              />
            </div>
          )}
        </div>
      </div>
    );
    // return (
    //   <div className="col-12 dashboardBG survey-height-1 pt-3">
    //     <div className="mt-3">
    //       <SurveyView
    //         data={this.state.surveyDetails}
    //         sendData={this.getSurveyData}
    //         formData={this.state.formData}
    //       />
    //     </div>
    //   </div>
    // );
  }
}

export default SurveyContainer;
